import { AsyncPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Language, mapIso2CodeToIso2CodeLanguage } from "@ankaadia/ankaadia-shared";
import { translateSafely } from "@ankaadia/ankaadia-shared-frontend";
import { FloatLabel } from "primeng/floatlabel";
import { Select } from "primeng/select";
import { Tooltip } from "primeng/tooltip";
import { NewUiFlagComponent } from "../../../shared/flag/new-ui-flag.component";
import { NewUiFormElementMapModule } from "../../../shared/from-element-map/new-ui-form-element-map.module";
import { NewUiDropdownSortOnTopDirective } from "../../../shared/primeng/dropdown-sort-selected-value-on-top/new-ui-dropdown-sort-on-top.directive";
import { SettingsService } from "../../../shared/services/settings.service";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { MessageService } from "../../message/message.service";
import { UsersService } from "../users.service";

@Component({
  selector: "new-ui-communication-language",
  templateUrl: "./new-ui-communication-language.component.html",
  imports: [
    TranslateDirective,
    Select,
    NewUiDropdownSortOnTopDirective,
    FormsModule,
    AsyncPipe,
    FloatLabel,
    NewUiFlagComponent,
    NewUiFormElementMapModule,
    Tooltip,
  ],
})
export class NewUiCommunicationLanguageComponent implements OnInit {
  protected preferredCommunicationLanguage?: Language;

  readonly availableLanguages$ = this.userSvc.getAvailableCommunicationLanguages(this.settings.isCandidate);

  @Input()
  label?: string;

  constructor(
    private readonly userSvc: UsersService,
    private readonly settings: SettingsService,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    if (this.settings.communicationLanguage)
      this.preferredCommunicationLanguage = mapIso2CodeToIso2CodeLanguage(this.settings.communicationLanguage);
  }

  onClick(event: Event): void {
    event.stopPropagation();
  }

  setCommunicationLanguage(): void {
    this.userSvc.setCommunicationLanguage(this.preferredCommunicationLanguage.code).subscribe(() => {
      this.messageService.add({ severity: "success", summary: translateSafely("userLanguage.changedSuccess") });
    });
  }
}
